"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=socket-room-option.js.map